import { IS_LOADING_NEWPROD_HOME } from "../../ActionType/actionTypes";

export function isLoadingNewProdHome(param) {
    return (dispatch) => {
        dispatch({
            type: IS_LOADING_NEWPROD_HOME, 
            payload: {
                isLoadingNewProdHome: param
            }
        })
    }
}